module.exports = __webpack_public_path__ + "static/media/checkbox.0ed53507.svg";